import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
  output,
} from '@angular/core';
import { GridDrawerComponent } from 'src/app/modules/admin/models';

@Component({
  standalone: false,
  selector: 'gstar-legal-disclaimer',
  templateUrl: 'legal-disclaimer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LegalDisclaimerComponent extends GridDrawerComponent<string> {
  showDrawer: InputSignal<boolean> = input(false);
  showDrawerChange = output<boolean>();

  visibleChange(visible: boolean): void {
    this.showDrawerChange.emit(visible);
  }
}
